import { BASEURL, ENDPOINTS } from '../endpoints';
import { SPXAPI } from '../interfaces';

const moveFiles = async (API: SPXAPI, targetFolderId: string, filesIds: string[]): Promise<void> => (
    API.put(BASEURL.backend(), ENDPOINTS.moveFiles(targetFolderId), { body: { file_ids: filesIds } })
);

export default moveFiles;
